import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import DigiposHub from "@/pages/DigiposHub";
import DigiposZen from "@/pages/DigiposZen";
import DigiposPrimex from "@/pages/DigiposPrimex";
import DigiposInsight from "@/pages/DigiposInsight";
import DigiposOngo from "@/pages/DigiposOngo";
import DigiposZento from "@/pages/DigiposZento";
import Hardware from "@/pages/Hardware";
import Contact from "@/pages/Contact";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/digipos" element={<DigiposHub />} />
            <Route path="/digipos/zen" element={<DigiposZen />} />
            <Route path="/digipos/primex" element={<DigiposPrimex />} />
            <Route path="/digipos/insight" element={<DigiposInsight />} />
            <Route path="/digipos/ongo" element={<DigiposOngo />} />
            <Route path="/digipos/zento" element={<DigiposZento />} />
            <Route path="/hardware" element={<Hardware />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
